import { useState } from 'react';
import { Modal } from '@mantine/core';
import useUploadAsset from '../../helpers/useUploadAsset';
import AssetForm from '../Assets/AssetForm';

import ErrorMessage from '../ErrorMessage';

const AiChatImagesUploadModal = ({ imagesUploadModalOpen, toggleImagesUploadModal, addFile }) => {
  const [userError, setUserError] = useState();

  const { uploadReferenceImage } = useUploadAsset(setUserError);

  return (
    <Modal opened={imagesUploadModalOpen} onClose={() => toggleImagesUploadModal()} title="Upload an image to describe">
      <AssetForm
        asset={{ title: '', description: '', url: '' }}
        saveAsset={(asset, file) =>
          uploadReferenceImage(asset, file, (assetUrl) => {
            addFile(assetUrl);
            toggleImagesUploadModal();
          })
        }
        closeModal={toggleImagesUploadModal}
        tab="images"
      />
      {userError && <ErrorMessage message={userError.message} />}
    </Modal>
  );
};

export default AiChatImagesUploadModal;
